export class UpdateGrupoTipoGarantiaRequest{
  public id!:number
  public descripcion!: string
  public idGrupo!:number
  public idCantidadesTipoGarantia!:number
}
